if ($('#frmNearbyLocations').length) {
    (function () {

        $(function () {
            var $form = $('#frmNearbyLocations');
            var storeId = (orderViewModel.store && orderViewModel.store.id) || 0;

            // if storeId not found in cached client storage, try to retrieve from hidden field
            if (storeId === 0) {
                storeId = $('#StoreId', $form).val();
            }

            var action = $form.attr('action');

            $('#StoreId', $form).val(storeId);

            // if geolocation is available
            if ("geolocation" in navigator) {
                navigator.permissions.query({ name: "geolocation" }).then((result) => {
                    if (result.state === "granted") {
                        ajaxGetResults(action, 'frmNearbyLocations');
                    }
                    else if (result.state === "prompt") {
                        navigator.geolocation.getCurrentPosition(function (position) {
                            var accuracy = position.coords.accuracy;

                            // per requirements, if accuracy within 1km, we'll use the geolocator position
                            if (accuracy <= 1000) {
                                var lat = position.coords.latitude, long = position.coords.longitude;
                                $('#UserLatitude', $form).val(lat);
                                $('#UserLongitude', $form).val(long);
                                ajaxGetResults(action, 'frmNearbyLocations');
                            }
                            else {
                                // else we use the StoreId 
                                ajaxGetResults(action, 'frmNearbyLocations');
                            }

                        },
                            function (error) {
                                // if getCurrentPosition returns an error for any reason, which includes the scenario where permission has been denied, we will proceed with StoreId
                                checkForStoreId(storeId, action);
                            });
                    }
                });
            }
            else {
                // else if navigator is unavailable, we try to use the store's position to calculate nearby restaurants
                checkForStoreId(storeId, action);
            }

        });


        // checks if we have a store Id and uses that for nearby locations
        // otherwise, it hides the Nearby Locations and shows alternate content instead.
        var checkForStoreId = function (storeId, action) {
            if (storeId > 0) {
                // do nothing else on the client side. the controller will use the Store Id
                ajaxGetResults(action, 'frmNearbyLocations');
            }
            else {
                // else if the store Id is unavailable, hide the Nearby Locations and instead show basic content.
                $('#nearby-restaurants-main-container').hide();
                $('#nearby-restaurants-alternate').show();
            }
        }

        function ajaxGetResults(postUrl, formId) {

            $.ajax({
                url: postUrl,
                type: 'POST',
                data: $('#' + formId).serialize(),
                success: function (data) {
                    var top3 = $(data).filter('#top-3-restaurants-content');
                    $('#top-3-restaurants').html(top3.html());

                    pageActions();
                },
                error: function (jqXhr) {
                    modalClose(true);

                    var errModel = subwayScript.showAjaxError(jqXhr, true);


                }
            });
        }

        function pageActions() {

        }
    })();
}
function setNearByStore(e) {
    var stUrl = $(e).attr('data-storeUrl');
    orderViewModel.store.address = $(e).attr('data-storeAddress');
    orderViewModel.store.address1 = $(e).attr('data-storeAddress');
    orderViewModel.store.id = $(e).attr('data-storeId');
    document.getElementById('nav-rest-text').innerHTML = $(e).attr('data-storeAddress');
    orderViewModel.save();
    window.location.assign(stUrl);
}